import { render, staticRenderFns } from "./addRecord.vue?vue&type=template&id=586036b8&scoped=true"
import script from "./addRecord.vue?vue&type=script&lang=js"
export * from "./addRecord.vue?vue&type=script&lang=js"
import style0 from "./addRecord.vue?vue&type=style&index=0&id=586036b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586036b8",
  null
  
)

export default component.exports